const theme = {
  token: {
    // fontFamily:
    //   '"Nordnet Mono", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    fontFamily:
      '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    borderRadius: 4,
    fontSize: 15
  },
  components: {
    Typography: {
      titleMarginBottom: '0.4rem'
    },
    Layout: {
      headerBg: 'rgb(221, 234, 253)',
      headerHeight: 100,
      siderWidth: 250,
      siderCollapsedWidth: 90,
      triggerHeight: 50
    }
  }
};

export default theme;
